import { Helmet } from "react-helmet-async"
import { menu } from "@/app/utils/constants"

const SEO = ({ post, titleOverride = "" }) => {
  const pathname = window.location.pathname
  const defaultContent = {
    title: "Di Sini Di Sana | Fine Dining in Ubud & Antique",
    description: "DI SINI DI SANA by Rachman & Sons is inspired by our love of our role models, the Loro Blonyo: the inseparable couple - my Papi and Mami who devoted their life not only to love each other, but to their family, home and humanity.",
    photo: "/src/assets/imgs/rachman-&-sons-official-logo-gold.png",
    keywords: "Di Sini Di Sana, disinidisana, Restoran Bali, Online Shop, Restoran Ubud, Toko Online Ubud, Bali Restaurant, Online Store, Ubud Restaurant, Ubud Online Store, Rachman & Sons, Rachman and Sons, Rachman Sons, Rachman & Sons Official"
  }

  const normalizePath = (path) => {
    if (!path) return "/"
    const clean = path.split("?")[0].split("#")[0]
    return clean.length > 1 ? clean.replace(/\/+$/, "") : clean
  }

  const toTitleCase = (text) => {
    return text
      .split(" ")
      .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : word))
      .join(" ")
  }

  const getMenuTitle = (path) => {
    const current = normalizePath(path)

    const labelOverrides = {
      "restaurant/di sini": "Di Sini",
      "store/di sana": "Di Sana"
    }

    for (const item of menu) {
      if (item.isBlank) continue
      const itemLink = item.link ? normalizePath(item.link) : ""
      const baseTitle = labelOverrides[item.label] || toTitleCase(item.label)

      if (itemLink && itemLink === current) return { baseTitle }

      if (item.details?.length) {
        for (const detail of item.details) {
          const detailLink = normalizePath(detail.link)
          if (current === detailLink || current.startsWith(`${detailLink}/`)) {
            return { baseTitle, detailTitle: detail.name }
          }
        }
      }

      if (itemLink && current.startsWith(`${itemLink}/`)) return { baseTitle }
    }

    return {}
  }

  const { baseTitle, detailTitle } = getMenuTitle(pathname)
  const siteTitle = "Di Sini Di Sana"
  const titleParts = []
  const normalizedPath = normalizePath(pathname)
  const isComingSoon = normalizedPath === "/coming-soon"
  const isNotFound = normalizedPath === "/page-not-found"
  const isBlogDetail = normalizedPath.startsWith("/blogs/") && normalizedPath.split("/").length === 3
  const isCulturalEventDetail = normalizedPath.startsWith("/cultural-events/") && normalizedPath.split("/").length === 3

  if (titleOverride) titleParts.push(titleOverride)
  if (!titleOverride && isComingSoon) titleParts.push("Coming Soon")
  if (!titleOverride && isNotFound) titleParts.push("Page Not Found")

  // Skip baseTitle completely for detail pages (blog & cultural events)
  if (baseTitle && !isBlogDetail && !isCulturalEventDetail) titleParts.push(baseTitle)

  if (detailTitle) titleParts.push(detailTitle)

  // Hanya gunakan post.name di detail pages
  if ((isBlogDetail || isCulturalEventDetail) && post?.name) titleParts.push(post.name)

  const pageTitle = titleParts.length
    ? ((isBlogDetail || isCulturalEventDetail) && post?.name
      ? post.name // Detail pages: hanya nama content
      : `${siteTitle} | ${titleParts.join(" | ")}`) // Lainnya: dengan site title
    : defaultContent.title

  const origin = window.location.origin
  const canonicalUrl = `${origin}${normalizePath(pathname)}`
  const description = post?.description || defaultContent.description
  const keywords = post?.keywords || defaultContent.keywords
  const photo = post?.photo || post?.image || defaultContent.photo

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <link rel="canonical" href={canonicalUrl} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="google" content="notranslate" />
      <meta name="robots" content="index,follow" />
      <meta name="googlebot" content="index,follow" />
      <meta name="author" content="Di Sini Di Sana by Rachman & Sons" />
      {/* Open Graph */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:site_name" content="DI SINI DI SANA" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={photo} />
      <meta property="article:author" content={canonicalUrl} />
    </Helmet>
  )
}

export default SEO
